import Compressor from "compressorjs";
import { useRouter } from "vue-router";
import { defineComponent, reactive, ref } from "vue";
import { showNotify } from "vant";
import { insertLeave } from "@/api/leave";
import { uploadNo } from "@/api/upload";
export default defineComponent({
  name: "LeaveAdd",
  setup() {
    var _JSON$parse;
    const router = useRouter();
    const name = (_JSON$parse = JSON.parse(localStorage.getItem("userInfo") || "{}")) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.name;
    ;
    let modelForm = reactive({
      beginTime: "",
      endTime: "",
      reason: "",
      attachment: ""
    });
    // 日期组件数据格式化显示
    const formatter = (type, option) => {
      if (type === "year") {
        option.text += "年";
      }
      if (type === "month") {
        option.text += "月";
      }
      if (type === "day") {
        option.text += "日";
      }
      if (type === "hour") {
        option.text += "时";
      }
      if (type === "minute") {
        option.text += "分";
      }
      // if (type === "second") {
      //   option.text += "秒";
      // }
      return option;
    };
    const date = new Date();
    let currentDate = ref([date.getFullYear(), date.getMonth() + 1, date.getDate()]),
      currentTime = ref(["00", "00"]),
      showPicker = ref(false);
    // 显示日期选择组件
    let field = ""; // 赋值字段
    const handlerClcikTime = fieldName => {
      field = fieldName;
      showPicker.value = true;
    };
    // 日期确认按钮操作
    const onConfirm = () => {
      // console.log(e, currentDate.value, currentTime.value);
      modelForm[field] = currentDate.value.join("-") + " " + currentTime.value.join(":");
      showPicker.value = false;
    };
    // 图片上传
    const fileList = ref([]);
    const beforeRead = async file => {
      await new Promise(resolve => {
        // compressorjs 默认开启 checkOrientation 选项
        // 会将图片修正为正确方向
        new Compressor(file, {
          success: resolve,
          error(err) {
            console.log(err.message);
          }
        });
      });
    };
    const onOversize = file => {
      showNotify({
        type: "warning",
        message: "上传图片大小不能超过10M"
      });
    };
    const afterRead = file => {
      // 此时可以自行将文件上传至服务器
      console.log(file, file.status, file.file);
      file.status = "uploading";
      file.message = "上传中...";
      // const formData = new FormData();
      // formData.append("file", file.file);
      uploadNo({
        file: file.file
      }).then(({
        data: {
          code,
          msg,
          data
        }
      }) => {
        console.log("then", code, msg);
        if (code !== 200) {
          file.status = "failed";
          file.message = "上传失败";
          fileList.value = [];
          return showNotify({
            type: "warning",
            message: msg
          });
        }
        file.status = "done";
        modelForm.attachment = data.fileName;
      }).catch(err => {
        file.status = "failed";
        file.message = "上传失败";
        showNotify({
          type: "warning",
          message: err.msg
        });
      });
    };
    const loading = ref(false);
    const onSubmit = values => {
      console.log("submit", modelForm);
      if (new Date(modelForm.beginTime).getTime() >= new Date(modelForm.endTime).getTime()) {
        showNotify({
          type: "danger",
          message: "请假开始时间不能大于等于截止时间"
        });
        return;
      }
      loading.value = true;
      insertLeave(modelForm).then(({
        code,
        msg
      }) => {
        if (code === 200) {
          router.go(-1);
          showNotify({
            type: "success",
            message: msg
          });
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    return {
      name,
      modelForm,
      showPicker,
      currentDate,
      currentTime,
      formatter,
      handlerClcikTime,
      onConfirm,
      fileList,
      beforeRead,
      afterRead,
      onOversize,
      loading,
      onSubmit
    };
  }
});